export const STRATEGIES = {
    lock: 'lock',
    walkthrough: 'walkthrough',
} as const;

export const defaultStrategy = STRATEGIES.lock;
